export default __webpack_public_path__ + "static/media/uploader-abbottLibre-3.584f8e52.png";